<template>
    <Head title="Register Apelido" />
    <GuestLayout>
        <article>
            <div class="sm:px-5 xl:max-w-[350px] xl:w-[350px]">
                <HeadingGuest title="Apelido" />
                <p class="pb-2">
                    Como você gostaria de ser
                    chamado(a)? Esse será o nome que
                    aparecerá na tela de início.
                </p>

                <form @submit.prevent="submit">
                    <ul class="grid gap-12 pt-4">
                        <li>
                            <label class="mb-1 mr-5 flex font-semibold">
                                Apelido
                            </label>
                            <Input
                                placeholder="Preecha aqui o seu apelido.."
                                type="text"
                                required
                                v-model="form.nickname"
                            />
                        </li>

                        <li>
                            <Button
                                class="
                                    w-full
                                    grid
                                    justify-items-center
                                    items-center
                                  text-primary
                                  hover:bg-gray-300
                                  border-primary border rounded
                                    hover:border-transparent
                                    font-semibold
                                    p-1.5
                                "
                            >
                                Avançar
                            </Button>
                        </li>
                    </ul>
                </form>
            </div>
        </article>
    </GuestLayout>
</template>

<script>
import HeaderComponent from "@/Components/Header.vue";
import Input from "@/Components/UI/Form/Input.vue";

import GuestLayout from "@/Layouts/Guest.vue";
import Label from "@/Components/Label.vue";
import ValidationErrors from "@/Components/ValidationErrors.vue";
import { Head, Link } from "@inertiajs/inertia-vue3";
import HeadingGuest from "@/Components/UI/Texts/HeadingGuest.vue"

export default {

    components: {
        HeaderComponent,
        Input,
        Label,
        ValidationErrors,
        Head,
        Link,
        GuestLayout,
        HeadingGuest
    },

    data() {
        return {
            form: this.$inertia.form({
                nickname: '',
            }),
        };
    },

    methods: {
        submit() {
            console.log(this.form);
            if(this.form.nickname) {
                sessionStorage.setItem('nickname', this.form.nickname)
                location.href = "/register/regulamento";
            }
        },
    },
};
</script>
